import clsx from 'clsx';
import { CrossIcon } from 'common/all-icons/custom-icons';

const DelesectionImageAction = ({
  handleRemove = () => {},
  iconClassName = '',
  iconSize = 15,
  icon = <CrossIcon style={{ color: '#fff' }} width={iconSize} height={iconSize} />,
}) => {
  return (
    <div
      onClick={handleRemove}
      style={{ '--icon-bg-color': '#00000080', cursor: 'pointer' }}
      className={clsx('attachment-action-icon', iconClassName)}
    >
      {icon}
    </div>
  );
};

export default DelesectionImageAction;
